import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  align-items: center;
  background: linear-gradient(231.01deg, #E6037F 20.98%, #99175C 90.65%);

  .info-bar{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  div.info-bar-text{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 25rem;

    h1{
      color: var(--white);
      font-size: 2.5rem;
      font-weight: 400;
    }

    h4{
      font-size: 1.3rem;
      font-weight: 300;
      line-height: 2.0425rem;
      color: var(--white);

      text-align: center;
    }
  }

  @media(max-width: 1440px){
    .info-bar{
      display: flex;
      align-items: center;
    }

    div.info-bar-text{
      margin-left: -2rem;
    }
  }

  @media(min-width: 1450px){
    div.info-bar-text{

      h1{
        color: var(--white);
        font-size: 2.5rem;
        font-weight: 400;
        margin-left: -14rem;
      }

      h4{
        font-size: 1.5rem;
        font-weight: 300;
        line-height: 2.0425rem;
        color: var(--white);
        margin-left: -14rem;
      }
    }
  }
`
